module.exports = "/_next/static/images/calculator-1d366e94ffd8e4985fe526a1dc4253c3.svg";